import { DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommControlActive extends Layout {
    panelActiveSection: Panel;
    sourceMCControl: DataSource;
    textboxActiveUnits: Textbox;
}
